import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Navigated to a section anchor (e.g. from site search). Wait briefly for
      // the target page to render, then scroll the element into view.
      const id = decodeURIComponent(hash.replace(/^#/, ""));
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempts < 10) {
          attempts += 1;
          setTimeout(tryScroll, 100);
        }
      };
      const timer = setTimeout(tryScroll, 50);
      return () => clearTimeout(timer);
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
